import { IApiService } from '../../services/ApiService';
import { ActionFunctionArgs, redirect } from 'react-router';
import { Logger } from '../../utils/Logger';

/**
 * Action pour déconnecter l'utilisateur
 * Appelé quand l'utilisateur soumet le formulaire logout (via LogoutPage)
 * Effectue le logout et redirige vers / (home)
 * Le loader de / détectera l'absence d'authentification et redirigera vers /account/login
 */
export function logoutAction(apiService: IApiService) {
  return async (_: ActionFunctionArgs) => {
    try {
      const controller = new AbortController();
      await apiService.logout(controller.signal);
      Logger.debug('logoutAction', '✅ Logout successful');
    } catch (error) {
      // Logout même si l'API échoue (session côté frontend purgée)
      Logger.error('logoutAction', '⚠️ Logout API failed:', error);
    }

    // Rediriger directement vers login
    // (Ne pas rediriger vers / car React Router ne relancerait pas le loader si on vient de /)
    // Redirection directe garantit que l'utilisateur voit la page de login immédiatement
    return redirect('/account/login');
  };
}
